module.exports = __webpack_public_path__ + "static/media/airbnb.291c7354.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/assets/airbnb.png
// module id = 831
// module chunks = 0